import * as React from "react";

export class TimedChangbleFrame extends React.Component<
    { childrenData: { timeOutMili: number, timedOutHandler?: () => void }[] },
    { currentChildIndex: number }
    > {

    constructor(props) {
        super(props)
        this.state = { currentChildIndex: 0 };
    }

    componentDidMount() {
        this.setNextFrame(this.state.currentChildIndex);
    }

    setNextFrame(index: number) {
        /* istanbul ignore next */
        if (index === this.props.childrenData.length) {
            /* istanbul ignore next */
            return;
        } else {
            setTimeout(() => {
                let handler = this.props.childrenData[index].timedOutHandler;
                handler && handler();
                this.setNextFrame(index + 1);
            }, this.props.childrenData[index].timeOutMili);

            this.setState({ currentChildIndex: index });
        }
    }

    render() {
        return (
            this.props.children && this.props.children[this.state.currentChildIndex]
        )
    }
}